import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import styles from './Discussion.module.scss';
import classNames from 'classnames';
import Dialog from './Dialog';
import VocabularWord from './VocabularWord';

export default class Discussion extends Component {
    static propTypes = {
        scenario: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    render() {
        const {scenario, onClose} = this.props;

        const scenarioQuestionWithoutDot = removeDotOnTheEnd(scenario.question);

        return (
            <Dialog
                visible
                renderIcon={this.renderIcon}
                okButtonLabel='Done'
                onClose={onClose}
            >
                <div className={styles.discussionContent}>
                    <header className={styles.header}>Discussion questions</header>

                    <div className={styles.paragraph}>
                        1) How might a belief that: "{scenarioQuestionWithoutDot}"
                        influence our thinking or actions around bullying?
                    </div>
                    <div className={styles.paragraph}>
                        2) How can facts help in communication and relationships?
                    </div>
                </div>
            </Dialog>
        );
    }

    renderIcon = () => {
        return <div className={styles.discussionIcon} />;
    };
}

function removeDotOnTheEnd(s) {
    s = s.trim();
    if (!s.endsWith('.')) return s;

    return s.slice(0, -1);
}
